'use client'

import { Carousel } from 'fukku/Carousel/components/Carousel'
import { CarouselVariants } from 'fukku/Carousel/types'
import type { OrderLine, Purchase } from 'my-purchases/types/purchaseList'
import { sendOnClickPurchaseDetail } from 'my-purchases/utils/analytics/analyticsEvents'
import { cardImageSizes } from 'utils/image/constants/cardImageSizes'
import { generateImagesSizes } from 'utils/image/generateImagesSizes/generateImagesSizes'

import { ArticleImage } from './components/ArticleImage/ArticleImage'
import { CarouselHeader } from './components/CarouselHeader/CarouselHeader'

import styles from './PurchaseCard.module.scss'

interface PurchaseCardProps {
	readonly purchase: Purchase
}
export function PurchaseCard({ purchase }: PurchaseCardProps) {
	const { orders, active, purchaseId } = purchase
	const articles = orders
		.flatMap((order) => order.lines)
		.filter((line): line is OrderLine => !!line)

	const onCardClick = () => {
		sendOnClickPurchaseDetail(purchase, active)
	}

	const baseTestId = `myPurchases.purchases.list.item.${purchaseId}`

	return (
		<div className={styles.container}>
			<Carousel
				customHeaderContent={
					<CarouselHeader
						purchase={purchase}
						onClick={onCardClick}
						dataTestId={`${baseTestId}.header`}
					/>
				}
				className={styles.carousel}
				variant={CarouselVariants.VARIANT3}
			>
				{articles.map((article) => (
					<ArticleImage
						key={`${purchase.purchaseId}-${article?.id}`}
						article={article}
						sizes={generateImagesSizes(cardImageSizes)}
						purchaseUrl={purchase.link}
						onClick={onCardClick}
						dataTestId={`${baseTestId}.article.${article?.id}`}
					/>
				))}
			</Carousel>
		</div>
	)
}
